import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';

import TerminalBasePopup from 'src/terminal/popups/TerminalBasePopup';

const TerminalLogoutPopup = ({ data, id }) => {
  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  return (
    <TerminalBasePopup
      buttonLabel="terminal_sign_out_popup_signout_button"
      className="terminal-logout-popup"
      onButtonClick={() => {
        data.onConfirm();
        handleClose();
      }}
      onSecondaryButtonClick={handleClose}
      secondaryButtonLabel="terminal_sign_out_popup_back_button"
      text="terminal_sign_out_popup_message"
      title="terminal_sign_out_popup_title"
    />
  );
};

TerminalLogoutPopup.propTypes = {
  data: PropTypes.object,
  id: PropTypes.string,
};

export default TerminalLogoutPopup;
